<template>
  <div id="inspire" class="app dashboard" @click="hiddenList">
    <app-drawer class="app--drawer" :show-drawer="showDrawer" :privileges="privileges" :isShowList ='isShowList' :isShowBtn="isShowBtn" :isShowName="isShowName"/>
    <app-toolbar @logout="logout" :privileges="privileges" class="app--toolbar" @side-icon-click="handleDrawerVisible" />
    <v-main>
      <!-- Page Header -->
      <div class="page-wrapper"><router-view /></div>
      <!-- App Footer -->
      <v-footer height="auto" class="white pa-3 app--footer">
        <span class="caption">POWERED BY <strong>SZT</strong> &copy; 2018-{{ new Date().getFullYear() }}</span>
        <v-spacer />
        <span class="caption mr-1">Built With Love</span>
        <v-icon color="pink" small>favorite</v-icon>
      </v-footer>
    </v-main>
    <v-card v-if="inactiveLoading">
      <div class="fakeLoader">
        <div class="tip-header">Are you there?</div>
        <div class="tip-text">You will be signed out automatically in {{ count }} seconds</div>
      </div>
    </v-card>
    <!-- Go to top -->
    <app-fab />
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import AppDrawer from '@/components/framesets/AppDrawer'
import AppToolbar from '@/components/framesets/AppToolbar'
import AppFab from '@/components/framesets/AppFab'
import { Cache, Tool, DataType, Sloth, Popup } from '@/util/index'
import { AlgorithmApi, AuthApi, SystemApi, OAuthApi, OriginationBusinessApi } from '@/api/pandaria'
const popup = new Popup()
const cache = new Cache()
const tool = new Tool()
export default {
  inject: ['reload'],
  components: {
    AppDrawer,
    AppToolbar,
    AppFab
  },

  data () {
    return {
      showDrawer: this.isShowDrawer(),
      privileges: [],
      slothUrl: '',
      sloth: null,
      inactiveLoading: false,
      count: 10,
      interCount: null,
      timer: null,
      isShowList: false,
      isShowBtn: true,
      isShowName: true
    }
  },
  async mounted () {
    const $this = this
    const accessToken = cache.getAccessToken()
    if (tool.isEmpty(accessToken)) {
      await $this.$router.replace({ path: '/sign-in' })
    }
    this.saveAccount(accessToken)
    this.saveAuthorization(accessToken)
    this.getSignOutReasonList(accessToken)
    this.getTimezoneOffset()
    await $this.generateHoliday()
    await $this.getNextBusinessDay()
    this.$eventBus.$on('side-icon-click', target => {
      this.handleDrawerVisible()
    })
    this.hasOperate()
    this.$eventBus.$on('updateIsShowList', target => {
      this.isShowList = target
    })
    this.$eventBus.$on('updateIsShowBtn', target => {
      this.isShowBtn = target
    })
    this.$eventBus.$on('updateIsShowName', target => {
      this.isShowName = target
    })
  },
  destroyed () {
    this.$eventBus.$off('updateIsShowList')
    this.$eventBus.$off('updateIsShowBtn')
    this.$eventBus.$off('updateIsShowName')
  },
  methods: {
    hiddenList () {
      if (this.isShowList === true) {
        this.isShowList = false
        this.isShowBtn = true
        this.isShowName = true
      }
    },
    isShowDrawer () {
      const href = location.href
      return href.indexOf('welcome') !== -1 || href.indexOf('workbench') !== -1 || href.indexOf('queue') !== -1
    },
    handleDrawerVisible () {
      this.showDrawer = !this.showDrawer
    },
    getTimezoneOffset () {
      const $this = this
      const data = {
        timeZoneType: DataType.TimeZoneTypeEnum.SERVER_SIDE.value
      }
      SystemApi.getTimezoneOffset(data, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.store.commit('setServerSideTimezone', result)
        }
      })
    },
    saveAccount (accessToken) {
      const $this = this
      AuthApi.getAccount(
        accessToken,
        function (result) {
          $this.initWebSocket(result)
          $this.store.commit('setAccount', result)
          $this.queryRoleName()
        }
      )
    },
    queryRoleName () {
      const _this = this
      const account = _this.$store.getters.getAccount
      if (tool.isNotEmpty(account.roleId)) {
        OAuthApi.listOAuthRoleNameById(
          { id: account.roleId },
          function (data) {
            _this.$store.commit('setRoleName', data.name)
            _this.$store.commit('setRoleCode', data.code)
            _this.$eventBus.$emit('updateAccount')
          }
        )
      }
    },
    saveAuthorization (accessToken) {
      const $this = this
      AuthApi.getAuthorization(
        accessToken,
        function (result) {
          $this.store.commit('setAuthorization', result)
          $this.privileges = result.privileges
        },
        function (result) {
          throw result.message
        }
      )
    },
    getSignOutReasonList () {
      const $this = this
      OriginationBusinessApi.getSignOutReasonList(null, (res) => {
        const result = tool.isNotEmpty(res) ? res : []
        $this.store.commit('setSignOutReasonList', result)
      })
    },
    async generateHoliday () {
      const $this = this
      const holidayInStore = $this.store.getters.getHoliday
      if (tool.isEmpty(holidayInStore)) {
        await AlgorithmApi.generateHoliday([], function (result) {
          const holiday = []
          if (tool.isNotEmpty(result)) {
            for (const key in result) {
              const holidayArray = result[key]
              if (tool.isNotEmpty(holidayArray)) {
                for (const holidayItem of holidayArray) {
                  holiday.push(holidayItem.holidayTimeStr)
                }
              }
            }
          }
          $this.store.commit('setHoliday', holiday)
        })
      }
    },
    async getNextBusinessDay () {
      const $this = this
      const nextBusinessDayInStore = $this.store.getters.getNextBusinessDay
      if (tool.isEmpty(nextBusinessDayInStore)) {
        await AlgorithmApi.getNextBusinessDay({ days: 1, hasDate: false }, function (data) {
          $this.store.commit('setNextBusinessDay', data[0])
        })
      }
    },
    judgeEnvironment () {
      const protocol = window.location.protocol === 'http:'
      switch (process.env.NODE_ENV) {
        case 'develop':
          if (protocol) {
            this.slothUrl = 'MICROSERVICE-WSXCH-DEV-V3-2.us-west-1.elasticbeanstalk.com:8407/v3'
          } else {
            this.slothUrl = 'wsxch3.sztnb.com/v3'
          }
          break
        case 'training':
          if (protocol) {
            this.slothUrl = 'MICROSERVICE-WSXCH-DEV-V3-2.us-west-1.elasticbeanstalk.com:8407/v3'
          } else {
            this.slothUrl = 'wsxch3.sztnh.com/v3'
          }
          break
        case 'production':
          if (protocol) {
            this.slothUrl = 'microservice-wsxch-rel-v3-2.ap-southeast-1.elasticbeanstalk.com:8407/v3'
          } else {
            this.slothUrl = 'wsxchv3e2.sztus.com/v3'
          }
          break
        default :
          this.slothUrl = process.env.VUE_APP_WEBSOCKET_URL
          break
      }
    },
    initWebSocket (account) {
      const $this = this
      $this.judgeEnvironment()
      let data = {}
      $this.sloth = new Sloth({
        url: $this.slothUrl,
        mode: 'ClientSide',
        wsid: account.openId
      })
      $this.sloth.init()
      $this.sloth.on('message', function (message) {
        if (message.data === DataType.LoanActionEnum.SIGN_OUT.value) {
          popup.popupForWarning('Your permissions have changed and you need to log in again',
            {
              confirmButtonText: 'OK'
            },
            function () {
              Cookies.set('portfolioSelected', '')
              cache.clear()
              $this.signOut()
            })
        }
        // AuthApi.online()
        switch (parseInt(message.data.ticket)) {
          case DataType.LoanActionEnum.GRAB_REQUEST.value:
            $this.$eventBus.$emit('grabLockRequest', message.data)
            break
          case DataType.LoanActionEnum.GRAB_ACCEPT.value:
            $this.$eventBus.$emit('grabLockAccept', message.data)
            $this.reload()
            break
          case DataType.LoanActionEnum.GRAB_REJECT.value:
            $this.$eventBus.$emit('grabLockReject', message.data)
            break
          case DataType.LoanActionEnum.CHANGE_SIGNATURE_STATUS.value:
            data = JSON.parse(message.data.message)
            $this.$eventBus.$emit('changeSignStatus', data)
            if (data.signStatus === DataType.SignStatusEnum.SIGNED.value &&
              tool.isNotEmpty(data.phase) && data.phase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value && tool.isEmpty(data.originalSignStatus)
            ) {
              $this.$eventBus.$emit('popSignedTips', data)
            }
            break
          case DataType.LoanActionEnum.LA_RECOVER.value:
            $this.$eventBus.$emit('reloadLoan')
            break
          case DataType.LoanActionEnum.EXECUTE_INTEGRATED_COMPUTATION.value:
            data = JSON.parse(message.data.message)
            $this.$eventBus.$emit('loanIntegratedComputationResult', data)
            break
          case DataType.LoanActionEnum.REOPEN_STAMP.value:
            data = JSON.parse(message.data.message)
            $this.$eventBus.$emit('reopenStamp', data)
            break
          case DataType.LoanActionEnum.UNLOCK.value:
            data = JSON.parse(message.data.message)
            if (data.action === 'Handle') {
              $this.$eventBus.$emit('handle', data)
            }
            break
          case DataType.LoanActionEnum.MLA_VERIFY.value:
            data = JSON.parse(message.data.message)
            $this.$eventBus.$emit('militaryLendingAct', data)
            break
          case DataType.LoanActionEnum.INSTANT_LITIGANT_VERIFICATION.value:
            data = JSON.parse(message.data.message)
            $this.$eventBus.$emit('instantLitigantVerification', data)
            break
          default:
            break
        }
      })
    },
    logout () {
      if (tool.isNotEmpty(this.sloth)) {
        this.sloth.close()
      }
    },
    hasOperate () {
      const showTime = 10 * 60
      const $this = this
      let time = showTime
      document.body.onmousemove = () => {
        activeEvent()
      }
      document.body.onmousedown = () => {
        activeEvent()
      }
      document.body.onscroll = () => {
        activeEvent()
      }
      document.body.onkeydown = () => {
        activeEvent()
      }
      document.body.onkeypress = () => {
        activeEvent()
      }
      document.body.onkeyup = () => {
        activeEvent()
      }
      const activeEvent = () => {
        if (!$this.$route.path.includes('sign-in')) {
          time = showTime
          $this.inactiveLoading = false
          clearInterval($this.timer)
          $this.timer = null
          $this.count = 10
          stopInterval()
          startInterval()
        }
      }
      const startInterval = () => {
        $this.interCount = setInterval(function () {
          --time
          if (time === 0 && !$this.$route.path.includes('sign-in')) {
            stopInterval()
            $this.showMessage()
          }
        }, 1000)
      }
      const stopInterval = () => {
        clearInterval($this.interCount)
        $this.interCount = null
      }
      startInterval()
      $this.$once('hook:beforeDestroy', () => {
        stopInterval()
      })
    },
    showMessage () {
      const $this = this
      this.inactiveLoading = true
      const startInterval = () => {
        $this.timer = setInterval(function () {
          $this.count--
          if ($this.count === 0) {
            $this.unlock()
            $this.signOut()
            stopInterval()
          }
        }, 1000)
      }
      const stopInterval = () => {
        clearInterval($this.timer)
        $this.timer = null
      }
      startInterval()
      $this.$once('hook:beforeDestroy', () => {
        stopInterval()
      })
    },
    unlock () {
      if (this.$route.params.uuid) {
        this.$eventBus.$emit('forceUnlock', { unlockReason: DataType.UnlockLoanReasonEnum.AUTO_UNLOCK_LEAVE_PAGE.value })
      }
    },
    signOut () {
      const data = { token: cache.getAccessToken() }
      AuthApi.signOut(data, function () {
        window.getApp.$emit('APP_LOGOUT')
        window._VMA.$emit('SHOW_SNACKBAR', {
          text: 'Logout Successful',
          color: 'success',
          timeout: 1000
        })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.page-wrapper
  min-height: calc(100vh - 64px - 50px - 42px)
.tip-header
  font-size: 60px
  text-align: center
  position: relative
  top: 50%
.tip-text
  font-size: 30px
  text-align: center
  position: relative
  top: 50%
</style>
